// extracted by mini-css-extract-plugin
module.exports = {"errorSpecific":"MutationErrorWarning_errorSpecific__2RbkL"};